
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Verify from "@/pages/Verify";
import CompanySetup from "@/pages/CompanySetup";
import Dashboard from "@/pages/Dashboard";
import FileDetails from "@/pages/FileDetails";
import ProductDetail from "@/pages/ProductDetail";
import NotFound from "@/pages/NotFound";
import UploadedFiles from "@/pages/UploadedFiles";
import { RequireCompanySetup } from "@/components/auth/RequireCompanySetup";
import { RequireSubscription } from "@/components/auth/RequireSubscription";
import Search from "@/pages/Search";
import CompetitorsDashboard from "@/pages/CompetitorsDashboard";
import Upgrade from "@/pages/Upgrade";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/verify" element={<Verify />} />
      <Route path="/company-setup" element={<CompanySetup />} />
      <Route path="/upgrade" element={<Upgrade />} />
      <Route
        path="/"
        element={
          <RequireCompanySetup>
            <Search/>
          </RequireCompanySetup>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireCompanySetup>
            <RequireSubscription feature="can_view_dashboard">
              <Dashboard />
            </RequireSubscription>
          </RequireCompanySetup>
        }
      />
      <Route
        path="/competitors-dashboard"
        element={
          <RequireCompanySetup>
            <RequireSubscription feature="can_view_competitors_dashboard">
              <CompetitorsDashboard />
            </RequireSubscription>
          </RequireCompanySetup>
        }
      />
      <Route
        path="/file-details/:id"
        element={
          <RequireCompanySetup>
            <RequireSubscription>
              <FileDetails />
            </RequireSubscription>
          </RequireCompanySetup>
        }
      />
      <Route
        path="/product/:id"
        element={
          <RequireCompanySetup>
            <RequireSubscription>
              <ProductDetail />
            </RequireSubscription>
          </RequireCompanySetup>
        }
      />
      <Route
        path="/uploaded-files"
        element={
          <RequireCompanySetup>
            <RequireSubscription>
              <UploadedFiles />
            </RequireSubscription>
          </RequireCompanySetup>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
